import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import MainButton from '../components/ButtonMain';
import Card from '../components/common/CardContent';
import Review from '../components/common/RatingStars';
import { colors} from '../styles/variables';
import { config as appConfig } from '../../config';

// import MainImage from '../images/main_image.png';
const MainImage = require('../images/deskimage.png')
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
     // height: '100vh',
      minHeight: 'calc(100vh - 80px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    topWrapper: {
      //marginBottom: '10vh',
      justifyContent:'center',
     
    },
    heading: {
      fontSize: '3.5em',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      marginBottom: '5vh',
      '& .red': {
        color: colors.red,
      },
      '@media only screen and (max-width: 959px)': {
        marginTop:'2rem',
        display:'flex',
        justifyContent:'center',
        fontSize: '2.5em',
        textAlign:'center',
        //paddingLeft:'2em'
        // maxWidth: "62%",
      },
    },
    control: {
      padding: theme.spacing(2),
    },
    container:{
      '@media only screen and (max-width: 959px)': {
        display:'contents',
        justifyContent:'center',
        paddingBottom:'1em'
       
        // maxWidth: "62%",
      },
      '@media only screen and (max-width: 755px)': {
        display:'flex',
        justifyContent:'center',
      },
    },
    mainContainer:{
      marginTop:'4em',
      '@media only screen and (max-width: 959px)': {
        justifyContent:'center',
        marginTop:0,
      
      },
      '@media only screen and (max-width: 755px)': {
        justifyContent:'center',
        marginTop:0,
       
      }
    },
    column:{
      '@media only screen and (max-width: 959px)': {
        display:'flex',
        justifyContent:'center'
        // maxWidth: "62%",
      },
    },
    column2:{
      '@media only screen and (max-width: 959px)': {
        display:'flex',
        justifyContent:'center',
        marginBottom:'20vh'
        // maxWidth: "62%",
      },
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      height: '100%',
      paddingRight: '5vw',
      paddingLeft: '5vw',
    },
    mainButtonDiv:{
      '@media only screen and (max-width: 959px)': {
        display:'flex',
        justifyContent:'center',
        paddingTop:0,
         // maxWidth: "62%",
      },
      '@media only screen and (max-width: 755px)': {
        paddingTop:0,
       
      }
    },
    imageWrapper: {
      textAlign: 'center',
      '@media only screen and (max-width: 959px)': {
       display:'none'
        // maxWidth: "62%",
      },
      '& img': {
        maxWidth: '510px',
      }
    },
  }),
);

export default function Intro() {
  const [] = React.useState<GridSpacing>(2);
  const classes = useStyles();
  const recordURL = appConfig.screenappFrontendBaseUrl + '#/recording'

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Grid container className={classes.topWrapper}>
          <Grid item md={6} sm={12}>
            <div className={classes.heading}>Online Screen<br /> Recorder</div>
            <div className={classes.mainButtonDiv}>
            <MainButton link={recordURL}>Get Started</MainButton>
            </div>
          
          </Grid>
          <Grid item md={6} className={classes.imageWrapper}>
            <img src={MainImage} alt='main-image' />
          </Grid>
        </Grid>
        <Grid container className={classes.mainContainer}>
          <Grid item md={6} className={classes.column} >
            <Grid container  className={classes.container}>
              <Grid item md={4}>
                <Card
                  redHeading="200,000"
                  description="Successful recordings every month"
                />
              </Grid>
              <Grid item md={4}>
            
               <Review reviewText="Reviews"/>
              
            </Grid>
            
            </Grid>
          </Grid>
          <Grid item md={6}  className={classes.column2}>
            <Grid container className={classes.container}  >
              <Grid item  md={4} xl={3} sm={12}>
                <Card
                  redHeading="100%"
                  heading="Free"
                  description="No registration or payment required"
                />
              </Grid>
              <Grid item  md={4} xl={3} sm={12}>
                <Card
                  redHeading="Instant"
                  heading="Recording"
                  description="No software downloads or extensions"
                />
              </Grid>
              <Grid item  md={4} xl={3} sm={12}>
                <Card
                  redHeading="Quick"
                  heading="Download"
                  description="Save recordings to your computer within seconds"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
       
      </div>
    </div>
  );
}
